"use client";
import clsx from "clsx";
import "./TabBar.scss";
import { Row } from "@/components";

type NavigationItem = {
  label: string;
  href: string;
  icon?: React.ComponentType<any>;
  active?: boolean;
  shortLabel?: string;
};

export type TabBarProps = {
  navigatonItems: NavigationItem[];
  asLink?: "a" | React.ComponentType<any>;
  className?: string;
};

export const TabBar = ({
  navigatonItems,
  asLink = "a",
  className,
}: TabBarProps) => {
  const LinkComponent = asLink;

  return (
    <nav className={clsx("bg-white ui-tab-bar shadow", className)}>
      <Row as={"ul"} className="list-style-none ui-tab-bar-list" role="list">
        {navigatonItems.map((item, index) => {
          const IconComponent = item?.icon;
          return (
            <li key={index} className="ui-tab-bar-item">
              <LinkComponent
                href={item.href}
                className={clsx(
                  "text-decoration-none text-secondary fs-8 fw-bold",
                  item.active && "active",
                )}
              >
                {IconComponent && (
                  <IconComponent
                    color={item.active ? "primary" : "secondary"}
                    filled={!!item.active}
                  />
                )}
                {item.shortLabel ? item.shortLabel : item.label}
                {item.active && <span className="visually-hidden">Attivo</span>}
              </LinkComponent>
            </li>
          );
        })}
      </Row>
    </nav>
  );
};
